import { apiRequest } from "../util/apiUtils";

export const enquiryList = async (params) => {
  try {
    const res = await apiRequest("get", `enquiry/list`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportEnquiryList = async (params) => {
  try {
    const res = await apiRequest("get", `enquiry/list-front`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const enquiryAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `enquiry/add`, {
      body: payload,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicContactAdd = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `form/post-response`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
